import { BaseState } from "..";
import { NameIdModel,RegionNameIdModel } from "../../app/data/common/models";

export default interface ServiceCentersState extends BaseState {
  origins?: NameIdModel[] | null;
  destinations?: NameIdModel[] | null;
  regions?: RegionNameIdModel[] | null;
}

export const initialServiceCentersState: ServiceCentersState = {
  origins: [],
  destinations: [],
  regions: [],
  loading: false,
  loadingFailed: false,
  loaded: false,
};
